import { Module } from '../api';
import i18n from '@/i18n';

export default (modules: Module[]): Module[] => {
  return modules.map((module: Module) => {
    const priceLabel = module.price
      ? i18n.t('global.fields.price', { price: i18n.n(module.price, 'currency', 'de-DE') })
      : i18n.t('global.fields.noAdditionalCost');

    // const description = [module.description, priceLabel].filter(_ => _).join('<br />');
    const description = `${module.description}<br />${priceLabel}`;

    return {
      ...module,
      description
    };
  });
};
